<template>
  <div
    v-if="address"
    class="content-block"
  >
    <h2 class="mb-4">
      Location
    </h2>
    <p><strong>{{ address }}</strong></p>
    <GoogleMap
      :api-key="getKey()"
      class="property-location"
      :center="mapCenter"
      :zoom="14"
      :zoom-control="true"
      :map-type-control="false"
      :scale-control="false"
      :street-view-control="false"
      :rotate-control="false"
      :fullscreen-control="false"
    >
      <Marker
        :options="{
          position: mapCenter,
          icon: require('@/assets/svg/marker.svg')
        }"
      />
    </GoogleMap>
  </div>
</template>

<script lang="ts">
/*eslint-disable */
import { Vue, Component, Prop, Watch } from "vue-facing-decorator";

import { GoogleMap, Marker } from 'vue3-google-map'

declare global {
  interface Window { google: any; }
}

@Component({
  components: {
    GoogleMap,
    Marker
  }
})

export default class PropertyLocation extends Vue {
  @Prop({ type: String }) address!: string;

  mapCenter = {lat: 38.8975, lng: -77.0366};

  getKey() {
    return process.env.NODE_ENV === 'production'
      ? 'AIzaSyCyk8umaS8NEYzavAJ2Xfua_ZKeL2eysjg'
      : 'AIzaSyCcgc7cylZn7kWNBY8D5jS_iYzsPTYDPqE'
  }
  setCenter() {
    if (!this.address || !window.google) return;
    let geocoder = new window.google.maps.Geocoder();

    geocoder.geocode({address: this.address}, (results, status) => {
      if (results && results.length) {
        this.mapCenter = results[0].geometry.location;
      }
    })
  }

  mounted () {
    const pingApi = setInterval(() => {
      if (window.google) {
        clearInterval(pingApi)
        this.setCenter()
      }
    }, 500);
  }
}
/* eslint-enable */
</script>

<style lang="scss">
  .property-location {
    height: 386px;
    width: 100%;
  }
</style>
